import { useAuth } from 'context/AuthContext';
import styles from './NoSubscriptionPage.module.css';

export default function NoSubscriptionPage() {
  const { logout, user } = useAuth();
  // D7: un admin sin ningún conjunto asignado caía aquí como "membresía vencida".
  const sinConjuntos = user?.role === 'admin' && user?.sin_conjuntos === true;

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div className={styles.pagina}>
      <div className={styles.columna}>

        {/* Logo */}
        <div className={styles.marca}>
          <div className={styles.marcaIcono}>
            <i className={`fas fa-vote-yea ${styles.marcaGlifo}`} />
          </div>
          <span className={styles.marcaNombre}>EVENTIFY</span>
        </div>

        {/* Card principal */}
        <div className={styles.tarjeta}>
          {/* Icono de bloqueo */}
          <div className={styles.bloqueo}>
            <i className={`fas fa-ban ${styles.bloqueoGlifo}`} />
          </div>

          <h1 className={styles.titulo}>
            {sinConjuntos ? 'Sin conjuntos asignados' : 'Acceso suspendido'}
          </h1>

          {sinConjuntos ? (
            <p className={styles.parrafo}>
              Tu cuenta ya no tiene conjuntos asignados en Eventify. Si sigues administrando
              un conjunto, pide al equipo de Eventify que te lo asigne.
              {user?.cuenta_se_cierra_el && (
                <><br /><br /><strong className={styles.destacado}>
                  Si no se te asigna un conjunto, esta cuenta de administrador se cerrará el{' '}
                  {new Date(user.cuenta_se_cierra_el).toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' })}.
                </strong></>
              )}
            </p>
          ) : (
          <p className={styles.parrafo}>
            La membresía de <strong className={styles.destacado}>{user?.name}</strong> ha vencido
            y el período de gracia ha expirado. Para continuar usando EVENTIFY
            es necesario renovar o activar una membresía.
          </p>
          )}

          {/* Qué incluye */}
          {!sinConjuntos && (<>
          <div className={styles.incluye}>
            <div className={styles.incluyeTitulo}>
              <i className={`fas fa-star ${styles.iconoEstrella}`} />
              Con una membresía activa puedes:
            </div>
            {[
              { icon: 'fa-gavel',           text: 'Crear y gestionar asambleas' },
              { icon: 'fa-users',           text: 'Registrar asistentes y representantes' },
              { icon: 'fa-circle-question', text: 'Crear preguntas y votaciones en tiempo real' },
              { icon: 'fa-chart-bar',       text: 'Ver resultados y proyectar en pantalla' },
              { icon: 'fa-file-pdf',        text: 'Generar el acta oficial en PDF' },
            ].map(item => (
              <div key={item.icon} className={styles.incluyeItem}>
                <div className={styles.incluyeIcono}>
                  <i className={`fas ${item.icon} ${styles.incluyeGlifo}`} />
                </div>
                {item.text}
              </div>
            ))}
          </div>

          {/* Contacto */}
          <div className={styles.contacto}>
            <i className={`fas fa-headset ${styles.iconoAyuda}`} />
            <strong>¿Necesitas ayuda?</strong> Contacta al administrador del sistema
            para renovar tu membresía y recuperar el acceso completo.
          </div>

          </>)}

          <button
            onClick={handleLogout}
            className={`btn btn-secondary ${styles.botonSalir}`}
          >
            <i className={`fas fa-right-from-bracket ${styles.iconoAyuda}`} />
            Cerrar sesión
          </button>
        </div>

        <p className={styles.pie}>
          EVENTIFY · Gestión inteligente de asambleas
        </p>
      </div>
    </div>
  );
}